import React from "react";

import { Box, Typography } from "@mui/material";
import { useTheme } from "@emotion/react";

const NotASubscriber = () => {
  const theme = useTheme();
  return (
    <Box
      display={"flex"}
      alignItems={"center"}
      flexDirection={"column"}
      height={"calc(100vh - 66px)"}
    >
      <img
        alt="yo"
        src="/images/server_down.svg"
        width="700px"
        height={"700px"}
      />
      <Typography
        mt={"-70px"}
        sx={{ color: theme?.palette?.primaryText?.[100] }}
        variant="h4"
      >
        Page Not Found
      </Typography>
    </Box>
  );
};

export default NotASubscriber;
